import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const NONE = "__none__";

export function TaskProjectFields({ task, onPatch, Prop }) {
  const [projects, setProjects] = useState([]);
  const [milestones, setMilestones] = useState([]);
  useEffect(() => { api.get("/projects").then((r) => setProjects(r.data.items || [])).catch(() => {}); }, []);
  useEffect(() => {
    if (!task.project_id) { setMilestones([]); return; }
    api.get(`/projects/${task.project_id}`).then((r) => setMilestones(r.data.milestones || [])).catch(() => setMilestones([]));
  }, [task.project_id]);
  const label = (p) => (p.person_name && !p.name.includes(p.person_name) ? `${p.name} — ${p.person_name}` : p.name);
  const known = projects.some((p) => p.id === task.project_id);
  return (
    <>
      <Prop label="Project">
        <Select value={task.project_id || NONE} onValueChange={(v) => onPatch({ project_id: v === NONE ? "" : v })}>
          <SelectTrigger className="h-9 text-sm" data-testid="detail-project"><SelectValue placeholder="No Project" /></SelectTrigger>
          <SelectContent className="bg-white max-h-72">
            <SelectItem value={NONE}>No Project</SelectItem>
            {!known && task.project_id && <SelectItem value={task.project_id}>{task.project_name || "Current project"}</SelectItem>}
            {projects.map((p) => <SelectItem key={p.id} value={p.id}>{label(p)}</SelectItem>)}
          </SelectContent>
        </Select>
      </Prop>
      {task.project_id && (
        <Prop label="Milestone">
          <Select value={task.milestone_id || NONE} onValueChange={(v) => onPatch({ milestone_id: v === NONE ? "" : v })}>
            <SelectTrigger className="h-9 text-sm" data-testid="detail-milestone"><SelectValue placeholder="No milestone" /></SelectTrigger>
            <SelectContent className="bg-white max-h-72">
              <SelectItem value={NONE}>No milestone</SelectItem>
              {milestones.map((m) => <SelectItem key={m.id} value={m.id}>{m.title}</SelectItem>)}
            </SelectContent>
          </Select>
        </Prop>
      )}
    </>
  );
}
